<template>
    <div>
        <el-upload
                :disabled="disabledInputs"
                class="add-file-uploader"
                drag
                action=""
                :http-request="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
        </el-upload>
        <!--{{fileListEdit}}-->
        <div class="tree" v-if="fileList.length !== 0">
            <div class="file" v-for="(item, index) in fileList" :key="index">
                <el-row class="flex-between file-item">
                    <el-col :span="20">
                        <div>{{item.name}}</div>
                    </el-col>
                    <el-row>
                        <el-button @click="viewFile(item.url)" type="warning" icon="el-icon-view" size="mini" plain></el-button>
                        <el-button @click="removeFile(index, item.url)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                    </el-row>
                </el-row>
            </div>
        </div>
        <div class="tree" v-if="fileListEdit.length !== 0">
            <div class="file" v-for="(item, index) in fileListEdit" :key="index">
                <el-row class="flex-between file-item">
                    <el-col :span="20">
                        <div>{{item.name}}</div>
                    </el-col>
                    <el-row>
                        <el-button @click="viewFile(item.url)" type="warning" icon="el-icon-view" size="mini" plain></el-button>
                        <el-button @click="removeFileEdit(index, item.url)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                    </el-row>
                </el-row>
            </div>
        </div>
        <!--<div v-if="viewerType == 1">-->
            <!--<sweet-modal blocking class="nested" v-if="viewerType == 1" ref="nestedChild">-->
                <!--<iframe class="iframe" :src="'https://docs.google.com/gview?url=' + fileUrl + '&embedded=true'" frameborder="0"></iframe>-->
            <!--</sweet-modal>-->
        <!--</div>-->
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import Media from '@dongido/vue-viaudio'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

  export default {
    props: ['disabledInputs','fileListEdit'],
    components: {
      SweetModal,

      Media
    },
    data() {
      return {
        modalLoading:false,
        imageUrl: '',
        fileList: [],
        fileUrl: '',
        type: '',
        viewerType: ''
      }
    },
    computed: {

    },
    methods: {
      handleAvatarSuccess( file, fileList ) {
        console.log("FILE",file);
        // this.form.imageUrl = URL.createObjectURL(file.raw);
        console.log('---', this.imageUrl);
        var formData = new FormData();
        formData.append('file', file.file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            console.log('---P', response.data);
            let newFileItem = {
              id: '',
              name: '',
              url: ''
            }
            newFileItem.name = file.file.name
            newFileItem.id = response.data.fileId
            newFileItem.url = response.data.fileUrl
            this.fileList.push(newFileItem)
            // this.fileList[0] = newFileItem
            this.imageUrl = response.data.fileUrl
            this.putFileIntoFormArray(response.data.fileId)

            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      putFileIntoFormArray(url){
        this.$emit('putFileIntoFormArray', url);
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
          this.$message.error('Avatar picture size can not exceed 2MB!');
        }
        return isLt2M;
      },
      viewFile(url) {
        this.fileUrl = url
        this.type = this.fileUrl.split('.').pop().toUpperCase()
        console.log('---', this.fileUrl, this.type);

        if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
          this.viewerType = 2;
          setTimeout(() => {
            console.log('-----', this.$el);
            const viewer = this.$el.querySelector('.images').$viewer
            viewer.show()
          }, 300);
        } else if (this.type == 'AVI' || this.type == 'MP4' || this.type == 'MOV') {
          this.viewerType = 3;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
          this.viewerType = 4;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else {
          this.viewerType = 1;
          setTimeout(() => {
            this.$emit('nestedChildOpen', url);
          }, 300);
        }
      },
      removeFile: function (index, url) {
        this.fileList.splice(index, 1);
        this.$emit('removeFile', url);
      },
      removeFileEdit: function (index, url) {
        this.fileListEdit.splice(index, 1);
        this.$emit('removeFile', url);
      }
    }
  }
</script>

<style lang="less" scoped>
    .flex-between{
        display:flex;
        justify-content:space-between;
    }
    .file-item{
        margin-bottom:10px;
    }
    /deep/.el-upload-list{
        display:none;
    }
    /deep/.add-file-uploader{
        width:100%;
        .el-upload{
            width:100%;
            .el-upload-dragger{
                width:100%;
            }
        }
    }
</style>

<style lang="less">
    .viewer-open{
        /deep/.viewer-container{
            z-index:99999 !important;
        }
        /deep/.sweet-modal-overlay{
            z-index:1 !important;
        }
    }
</style>


